import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/document`;

  constructor(private http: HttpClient) { }

  getDocumentUrl(taskPostId: number): string {
    return `${this.baseUrl}/Get/${taskPostId}`;
  }
}
